// components/MainPage/MainPageSkeleton.jsx
import React from 'react';
import './MainPageSkeleton.css';

const MainPageSkeleton = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="flex-1 min-w-0 flex flex-col">
        <main className="flex-1 p-8 min-w-0">
          <div className="space-y-6 animate-pulse">
            {/* Header skeleton */}
            <div className="flex items-center justify-between">
              <div>
                <div className="h-8 bg-gray-200 rounded w-48 mb-2"></div>
                <div className="h-4 bg-gray-200 rounded w-64"></div>
              </div>
              <div className="h-9 bg-gray-200 rounded w-28"></div>
            </div>

            {/* Three Stats Cards skeleton */}
            <div className="stats-cards-row">
              {[1, 2, 3].map((i) => (
                <div key={i} className="bg-white rounded-2xl p-5 border-l-4 border-gray-200 shadow-sm">
                  <div className="flex items-center gap-2 mb-3">
                    <div className="h-6 w-6 bg-gray-200 rounded-full"></div>
                    <div className="h-4 bg-gray-200 rounded w-32"></div>
                  </div>
                  <div className="h-10 bg-gray-200 rounded w-16 mb-2"></div>
                  <div className="h-3 bg-gray-200 rounded w-40 mb-4"></div>
                  <div className="space-y-2">
                    {[1, 2, 3].map((j) => (
                      <div key={j} className="flex justify-between">
                        <div className="h-3 bg-gray-200 rounded w-3/4"></div>
                        <div className="h-3 bg-gray-200 rounded w-8"></div>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>

            {/* Bottom Stats Bar skeleton */}
            <div className="stats-grid">
              {[1, 2, 3, 4, 5].map((i) => (
                <div key={i} className="stat-card-item">
                  <div className="h-8 bg-gray-200 rounded w-16 mx-auto mb-1"></div>
                  <div className="h-3 bg-gray-200 rounded w-20 mx-auto"></div>
                </div>
              ))}
            </div>

            {/* Positions skeleton */}
            <div className="bg-white rounded-2xl shadow-sm p-5">
              <div className="flex items-center gap-2">
                <div className="h-5 w-5 bg-gray-200 rounded"></div>
                <div className="h-5 bg-gray-200 rounded w-48"></div>
                <div className="h-5 bg-gray-200 rounded-full w-8"></div>
              </div>
            </div>

            {/* Upcoming Trainings skeleton */}
            <div className="bg-white rounded-2xl shadow-sm p-5">
              <div className="flex items-center justify-between mb-4">
                <div className="flex items-center gap-2">
                  <div className="h-4 w-4 bg-gray-200 rounded"></div>
                  <div className="h-4 bg-gray-200 rounded w-40"></div>
                </div>
                <div className="h-4 bg-gray-200 rounded w-12"></div>
              </div>
              <div className="text-center py-6">
                <div className="h-4 bg-gray-200 rounded w-48 mx-auto mb-3"></div>
                <div className="h-9 bg-gray-200 rounded w-24 mx-auto"></div>
              </div>
            </div>

            {/* Attention Required skeleton */}
            <div>
              <div className="h-7 bg-gray-200 rounded w-48 mb-3"></div>
              
              {/* Tabs skeleton */}
              <div className="flex gap-1 mb-4">
                {[1, 2, 3].map((i) => (
                  <div key={i} className="h-9 bg-gray-200 rounded-lg w-32"></div>
                ))}
              </div>

              {/* Grouping buttons skeleton */}
              <div className="flex items-center gap-2 mb-4">
                <div className="h-4 bg-gray-200 rounded w-20"></div>
                {[1, 2, 3].map((i) => (
                  <div key={i} className="h-8 bg-gray-200 rounded w-24"></div>
                ))}
              </div>

              {/* Filters skeleton */}
              <div className="flex gap-2 mb-4">
                {[1, 2, 3].map((i) => (
                  <div key={i} className="h-9 bg-gray-200 rounded w-48"></div>
                ))}
              </div>

              {/* Items skeleton */}
              <div className="space-y-3">
                {[1, 2, 3, 4, 5].map((i) => (
                  <div key={i} className="bg-white rounded-xl shadow-sm overflow-hidden border border-gray-100">
                    <div className="flex">
                      <div className="w-1.5 bg-gray-200 flex-shrink-0"></div>
                      <div className="flex-1 p-4">
                        <div className="flex items-start gap-4">
                          <div className="flex-1">
                            <div className="flex items-center gap-2 mb-2">
                              <div className="h-4 bg-gray-200 rounded w-32"></div>
                              <div className="h-5 bg-gray-200 rounded-full w-20"></div>
                              <div className="h-3 bg-gray-200 rounded w-16"></div>
                            </div>
                            <div className="h-4 bg-gray-200 rounded w-48 mb-2"></div>
                            <div className="flex items-center gap-3">
                              <div className="h-3 bg-gray-200 rounded w-24"></div>
                              <div className="h-3 bg-gray-200 rounded w-16"></div>
                              <div className="h-3 bg-gray-200 rounded w-20"></div>
                            </div>
                          </div>
                          <div className="flex gap-1">
                            <div className="h-9 bg-gray-200 rounded w-24"></div>
                            <div className="h-9 bg-gray-200 rounded w-24"></div>
                            <div className="h-9 bg-gray-200 rounded w-9"></div>
                            <div className="h-9 bg-gray-200 rounded w-9"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </main>
        <footer className="text-center py-4 text-xs text-gray-400 border-t border-gray-100">
          <div className="h-4 bg-gray-200 rounded w-48 mx-auto"></div>
        </footer>
      </div>
    </div>
  );
};

export default MainPageSkeleton;